"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidCriterion = exports.invalidCriterionProperties = void 0;
var isNumericProperty_1 = require("./isNumericProperty");
var isNumericValue_1 = require("./isNumericValue");
exports.invalidCriterionProperties = [
    'typeID',
    'hydrogenInterruptible',
    'notes',
    'upgradableTypes',
    'label',
    'name',
    'icon',
    'color',
    'carbonCertificates',
    'hydrogenStorageCapacity',
    'hydrogenInterruptible',
    'hydrogenRunningTariff',
    'conversionEfficiency',
    'storageEfficiency'
];
var isValidCriterion = function (criterion, assetTypeDefinitions) {
    // Check valid property chosen
    if (criterion.property === '' ||
        exports.invalidCriterionProperties.includes(criterion.property) ||
        !assetTypeDefinitions.find(function (assetTypeDefinition) { return assetTypeDefinition.columnName === criterion.property; })) {
        return false;
    }
    var isNumeric = (0, isNumericProperty_1.isNumericProperty)(criterion.property, assetTypeDefinitions);
    // Check value is valid for property
    if (isNumeric && !(0, isNumericValue_1.isNumericValue)(criterion.value)) {
        return false;
    }
    // The criterion has passed the validation
    return true;
};
exports.isValidCriterion = isValidCriterion;
//# sourceMappingURL=isValidCriterion.js.map